var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.98 146.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.59,
    y1: 108.08,
    x2: 166.73,
    y2: 108.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70519a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#684895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#513089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f2e88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 54.67,
    y1: 84.2,
    x2: 190.98,
    y2: 84.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3,
    y1: 68.78,
    x2: 48.42,
    y2: 68.78,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.23,166.38l-55.13-57A8.92,8.92,0,0,1,37,97.12L54.5,78.32a8.92,8.92,0,0,1,12.92-.14l23.44,24.1a8.92,8.92,0,0,0,12.65.13L158.3,48.48a5,5,0,0,1,6.95,7.06l-61.89,60.92a8.92,8.92,0,0,1-12.65-.14L67.58,92.55a8.91,8.91,0,0,0-12.92.14l-4,4.3a8.94,8.94,0,0,0,.12,12.29L92,151.93a8.93,8.93,0,0,0,13-.19L120.36,135a5,5,0,0,1,7.31,6.68L105.23,166.2A8.93,8.93,0,0,1,92.23,166.38Z",
    transform: "translate(-3 -22.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.06,142.46a10,10,0,0,1-14.3,0L56.09,105.39a5,5,0,0,1,7-7L92.7,128.36a10,10,0,0,0,14.3-.06l67.24-69.16a10,10,0,0,0-.1-14.06L169,39.93a10,10,0,0,0-14.25.1L105.4,90.68a10,10,0,0,1-14,.31L78.14,78.55a5,5,0,1,1,6.78-7.22l6.15,5.78a10,10,0,0,0,14-.31l49.55-50.87a10,10,0,0,1,14.25-.09L188.05,45a10,10,0,0,1,.1,14.06Z",
    transform: "translate(-3 -22.9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.78,91.47A22.71,22.71,0,1,1,48.4,69.84,22.75,22.75,0,0,1,26.78,91.47ZM26.88,56A12.81,12.81,0,1,0,38.47,67.61,12.82,12.82,0,0,0,26.88,56Z",
    transform: "translate(-3 -22.9)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.6ec6d1ecb337b84b5b80d13211f2d5f3.svg";
export { ForwardRef as ReactComponent };